// Auto-generated from Foundry artifacts — DO NOT EDIT
// Source: packages/vault/contracts/out/IdentityRegistryAdapter.sol/IdentityRegistryAdapter.json

export const IDENTITY_REGISTRY_ADAPTER_ABI = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_identityRegistry",
        type: "address",
        internalType: "address",
      },
      {
        name: "_reputationRegistry",
        type: "address",
        internalType: "address",
      },
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "UPGRADE_TIMELOCK",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "acceptOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "cancelRegistryUpdate",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "executeRegistryUpdate",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "getAgentWallet",
    inputs: [
      {
        name: "agentId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getEffectiveReputation",
    inputs: [
      {
        name: "agentId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "score",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "tier",
        type: "uint8",
        internalType: "enum Tier",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "identityRegistry",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IIdentityRegistry",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isCredentialFrozen",
    inputs: [
      {
        name: "agentId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isValidAgent",
    inputs: [
      {
        name: "agentId",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pendingIdentityRegistry",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pendingOwner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pendingReputationRegistry",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "proposeRegistryUpdate",
    inputs: [
      {
        name: "newIdentity",
        type: "address",
        internalType: "address",
      },
      {
        name: "newReputation",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "reputationRegistry",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IReputationRegistry",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "upgradeExecutableAfter",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "event",
    name: "OwnershipTransferStarted",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RegistryUpdateCancelled",
    inputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "RegistryUpdateExecuted",
    inputs: [
      {
        name: "newIdentity",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newReputation",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RegistryUpdateProposed",
    inputs: [
      {
        name: "newIdentity",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newReputation",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "executeAfter",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "AgentNotRegistered",
    inputs: [],
  },
  {
    type: "error",
    name: "CredentialFrozen",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidAgentId",
    inputs: [],
  },
  {
    type: "error",
    name: "NoUpgradePending",
    inputs: [],
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "TimelockNotElapsed",
    inputs: [],
  },
] as const;

export const IDENTITY_REGISTRY_ADAPTER_BYTECODE =
  "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" as const;
